export const IMAGEKIT_URL = 'https://ik.imagekit.io/lqd';

export const lqdImageUrl = (imgFilename: string) => {
  return `${IMAGEKIT_URL}/${imgFilename}`;
};

export const imgAssets = {
  brand: {
    logo: lqdImageUrl('lqd-logo.jpg'),
    meta: lqdImageUrl('lqd-meta.png')
  },
  avatars: {
    placeholder: lqdImageUrl('profile-placeholder.svg')
  },
  menus: {
    cocktailMenu: lqdImageUrl('cocktail-menu.jpg'),
    rocksGlass: lqdImageUrl('cocktail-rocks-glass.jpg')
  },
  personas: {
    angryBartender: lqdImageUrl('bartender_angry.jpg'),
    beachBartender: lqdImageUrl('bartender-beach.jpg'),
    sadBartender: lqdImageUrl('bartender-sad.jpg')
  }
};
